// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#roleTable {
    color: black;
}
#recommendationTable {
    color: black;
    border-color: black;
    border-width: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/recommendation/recommendation.component.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":["\n#roleTable {\n    color: black;\n}\n#recommendationTable {\n    color: black;\n    border-color: black;\n    border-width: 1;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
